import React, { useState } from "react";
import theme from "@/theme";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { CORPORATION } from "@/constants";

export const Register = (props = {}) => {
  const [fields, setFields] = useState(props.fields);
  const [politicalParty, setPoliticalParty] = useState(props.politicalParty);

  const handleFieldChange = (event = {}) => {
    const { target = {} } = event;
    const { value = "", name = "" } = target;
    setFields({ ...fields, [name]: value });
  };

  const getSubmitPayload = () => {
    const mappedFields = props.fields.map((field) => {
      const matchFieldByNumber = fields.hasOwnProperty(field.numero);
      if (matchFieldByNumber) {
        field.votos = Math.abs(parseInt(fields[field.numero]));
      }
      if (field.votos === null || Number.isNaN(field.votos)) {
        field.votos = 0;
      }
      return field;
    });
    const result = {
      politicalParty: Math.abs(parseInt(politicalParty)),
      fields: mappedFields,
    };
    return result;
  };

  const handlePoliticalPartyChange = (event) => {
    setPoliticalParty(event.target.value);
  };

  return (
    <Grid
      sx={{
        margin: "50px auto",
        textAlign: "center",
        paddingLeft: "15px",
        paddingRight: "15px",
        width: "100%",
      }}
    >
      <Grid container>
        <FormControl
          sx={{ width: "100%", marginBottom: "20px" }}
          variant="standard"
        >
          <InputLabel>{props.labels.politicalParty}</InputLabel>
          <Input
            type={"number"}
            onChange={handlePoliticalPartyChange}
            defaultValue={politicalParty || 0}
          />
        </FormControl>
      </Grid>

      {props.corporation !== CORPORATION.CONSULTA &&
        props.fields.map(({ nombre = "", numero = "", votos = 0 }, index) => (
          <Box key={index}>
            <Box
              sx={{
                color: "white",
                fontWeight: "bold",
                backgroundColor: theme.palette.primary.main,
                marginRight: "20px",
                height: "50px",
                width: "40px",
                textAlign: "center",
                padding: "0px",
                paddingTop: "15px",
              }}
            >
              {numero}
            </Box>
            <Box>
              <FormControl
                sx={{ marginBottom: "20px", marginTop: "10px", width: "100%" }}
                variant="standard"
              >
                <InputLabel>{nombre}</InputLabel>
                <Input
                  type={"number"}
                  name={String(numero)}
                  defaultValue={votos || 0}
                  onChange={handleFieldChange}
                  inputProps={{ min: 0 }}
                />
              </FormControl>
            </Box>
          </Box>
        ))}

      <Button
        onClick={() => props.onSubmit(getSubmitPayload())}
        variant="contained"
        sx={{ width: "100%", backgroundColor: theme.palette.primary.main }}
      >
        {props.labels.save}
      </Button>
    </Grid>
  );
};

export default Register;
